import Router from 'vue-router'

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: () => import('../Download.vue')
		},
		{
			path: '/enterprise_Intr',
			component: () => import('../pages/EnterpriseIntr.vue')
		}
	]
})

export default router
